import isEmpty from './isEmpty'
//---------------------
// set profile changes
//---------------------
export default function setProfileChanges(original_profile) {
  //-------------
  // init object
  //-------------
  let changed_profile = {}
  changed_profile.payload = {}
  //-------------------------------------------------------
  // set changed profile entries based on original profile
  //-------------------------------------------------------
  for (const [key, value] of Object.entries(original_profile)) {
    if (!isEmpty(value)) {
      changed_profile.payload[key] = value
    }
  }
  return changed_profile
}
